import { audioNodesSlice } from "./slice";

export const {
	addAudioNode,
	removeAudioNode,
	duplicateAudioNode,
	updateAudioNodeLabel,
	updateAudioNodeProps,
} = audioNodesSlice.actions;
